import * as React from 'react'
import { OnboardingComponentProps } from '.'

export const IntrinsicElement: React.FC<OnboardingComponentProps> = React.memo(
  ({
    intrinsicElementType,
    apiPath,
    templateResponseData,
    clearOnChange,
    ...props
  }) => {
    return React.createElement(intrinsicElementType, props)
  }
)
